import {ActivityIndicator, View} from "react-native"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"

/** @type {Record<string, object>} */
const styles = {}

export default memo(shapeComponent(class ComponentsLayoutLoadingSpinner extends ShapeComponent {
  static propTypes = propTypesExact({
    color: PropTypes.string
  })

  render() {
    const {color} = this.props

    return (
      <View
        style={styles.container ||= {alignItems: "center", justifyContent: "center", width: "100%", height: "100%"}}
      >
        <ActivityIndicator color={color} size="large" />
      </View>
    )
  }
}))
